"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requireWFFlavorAsset = exports.FLAVOR_STYLE_CONFIG = void 0;
var utils_1 = require("./utils");
exports.FLAVOR_STYLE_CONFIG = requireWFFlavorAsset('styles.json');
function requireWFFlavorAsset(file) {
    // eslint-disable-next-line
    return (0, utils_1.interop)(require("../flavors/".concat(process.env.REACT_APP_CONFIG_FLAVOR, "/").concat(file)));
}
exports.requireWFFlavorAsset = requireWFFlavorAsset;
